import { useState, useEffect } from 'react';
import PT from 'prop-types';
import { Icon } from 'edrolo-style-guide';
import s from './styles.scss';
import { SAVE_STATUS } from 'edrolo/constants/SaveStatus';

const stateMap = {
  [SAVE_STATUS.SAVED]: { icon: 'saved', text: 'Saved' },
  [SAVE_STATUS.SAVING]: { icon: 'saving', text: 'Saving...' },
  [SAVE_STATUS.ERROR]: { icon: 'not-saved', text: `Couldn't save` },
};

export const SaveStatus = ({ status }) => {
  const [displayedStatus, setDisplayedStatus] = useState(status);

  useEffect(() => {
    const delay = status === SAVE_STATUS.SAVED ? 500 : 0;

    setTimeout(() => {
      setDisplayedStatus(status);
    }, delay);
  }, [status]);

  return (
    <div className={s.status}>
      <span>
        <Icon name={stateMap[displayedStatus].icon} />
        {stateMap[displayedStatus].text}
      </span>
    </div>
  );
};

SaveStatus.propTypes = {
  status: PT.oneOf(Object.values(SAVE_STATUS)),
};
